import { asyncStart } from '../../../common';
import { JobNames, GET_FLIGHT_PLAN } from '../../../FlightPlan/+store/flightPlan';

export const GET_REPORT = 'aToF.getReport';
export const getReport = ({
  schoolYear,
  assessmentsInfo,
  campusDistrictNumber,
  filters,
  option,
  ignoreCache,
  ignoreTests,
  debug,
  jobName,
}) => (dispatch) => {
  let model;
  if (jobName === JobNames.aToF) {
    model = GET_REPORT;
  } else {
    model = GET_FLIGHT_PLAN;
  }
  dispatch(asyncStart(model, null, { campusDistrictNumber }));
  dispatch({
    type: model,
    schoolYear,
    assessmentsInfo,
    campusDistrictNumber,
    filters,
    option,
    ignoreCache,
    ignoreTests,
    debug,
    jobName,
  });
};

export const GET_FILTER_FIELDS = 'aToF.getFilterFields';
export const getFilterFields = (schoolYear, assessmentsInfo, campusDistrictNumber, filters) => (dispatch) => {
  dispatch(asyncStart(GET_FILTER_FIELDS));
  dispatch({
    type: GET_FILTER_FIELDS,
    schoolYear,
    assessmentsInfo,
    campusDistrictNumber,
    filters,
  });
};

export const UPDATE_FILTERS = 'aToF.updateFilters';
export const updateFilters = (filters) => ({
  type: UPDATE_FILTERS,
  filters,
});

// A report on screen describes the filters it was RUN with, not whatever the filter bar
// currently reads. Changing a filter without pressing Get Report used to leave the old
// numbers sitting there under new-looking filters, which reads as if they refreshed.
// Marking the run stale lets each report page swap its body for a prompt while keeping the
// report itself in the store, so Cancel can put it straight back.
export const SET_REPORT_STALE = 'aToF.setReportStale';
export const setReportStale = (stale) => ({
  type: SET_REPORT_STALE,
  stale,
});

// Snapshot of what actually produced the report on screen: the redux filters plus the score
// option, which lives in the filter component's own state rather than in `filters`.
export const SET_LAST_RUN = 'aToF.setLastRun';
export const setLastRun = (filters, option) => ({
  type: SET_LAST_RUN,
  filters,
  option,
});

// Cancel: put the filter bar back exactly as it was when the visible report was run, and
// clear the stale flag so the report reappears. The token increments so the filter
// component can also restore the score option, which redux does not own.
export const RESTORE_LAST_RUN = 'aToF.restoreLastRun';
export const restoreLastRun = () => (dispatch, getState) => {
  const lastRun = getState().modules.AtoF.aToF.lastRun;
  if (lastRun && lastRun.filters) {
    dispatch(updateFilters(lastRun.filters));
  }
  dispatch({ type: RESTORE_LAST_RUN });
};

// D2a growth matrix re-rowed on a chosen baseline set. Carries the report's own
// request (schoolYear / assessmentsInfo / campus / filters / option) so the
// server scopes the columns exactly like the report on screen.
export const GET_GROWTH_MATRIX = 'aToF.getGrowthMatrix';
export const getGrowthMatrix = ({ reportRequest, baseline }) => (dispatch) => {
  dispatch(asyncStart(GET_GROWTH_MATRIX, null, { baseline }));
  dispatch({
    type: GET_GROWTH_MATRIX,
    reportRequest,
    baseline,
  });
};

export const CLEAR_GROWTH_MATRIX = 'aToF.clearGrowthMatrix';
export const clearGrowthMatrix = () => ({
  type: CLEAR_GROWTH_MATRIX,
});

export const CLOSE_STUDENTS_LIST = 'aToF.closeStudentsList';
export const closeStudentsList = () => ({
  type: CLOSE_STUDENTS_LIST,
});

export const GET_STUDENTS_LIST = 'aToF.getStudentsList';
export const getStudentsList = (orgId, path, rowLabel, indicatorLabel) => (dispatch) => {
  dispatch(asyncStart(GET_STUDENTS_LIST));
  dispatch({
    type: GET_STUDENTS_LIST,
    orgId,
    path,
    rowLabel,
    indicatorLabel,
  });
};
